'use strict';

import mCustomScrollbar from 'mCustomScrollbar';

import '../../_assets/abbott/js/_modernizr';
import { debounce } from '../../_assets/abbott/js/_helper';

let $body = $('body'),
    $window = $(window),
    isMobileDevice = Modernizr.mq('(max-width: 767px)');

export default class Dropdown {
    constructor() {
        $(document).on("click", ".cta-dropdown", function(e){
            let $target = $(e.target);
            let $btn = $(this);
            $btn.toggleClass("open");
            // $(".cta-dropdown").each(function(idx, el){
            //     if(el == $btn.get(0)) {
            //         return;
            //     }
            //     $(el).removeClass("cta-dropdown");
            // });
        });
        
        $(document).on("click", function(e){
            let $target = $(e.target);
            if(!$target.hasClass("cta-dropdown") && $target.parents(".cta-dropdown").length == 0) {
                $(".cta-dropdown").removeClass("open");
            }
        });

        $('.js-toggle-login, .js-toggle-switch').on('click', function () {
            let $this = $(this);

            isMobileDevice = Modernizr.mq('(max-width: 767px)');

            if (isMobileDevice) {
                $this.find('.dropdown__switch--options').slideToggle({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                $this.find('.dropdown__account--options').slideToggle({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            } else {
                $this.toggleClass('active');
            }
        }).on('keypress', function (e) {
            let code = e.keyCode || e.which;

            if (code == 13) {
                //Do something
                $('.js-toggle-login').trigger('click');
            }
        });

        if ($('.dropdown__switch--institutions').length) {
            $('.dropdown__switch--institutions').mCustomScrollbar({
                setTop: 0,
                setHeight: 200,
                theme: 'minimal-dark',
                scrollbarPosition: 'outside'
                // SET SCROLLABALE
            });
        }

        //Making switch institution buttons into a form submit
        $('.dropdown__switch--institutions li').on('click', function (e){
            e.preventDefault();

            let $this = $(this),
                $form = $this.closest('form'),
                $institutionInput = $form.find('input[name*=workplaceId]'),
                institutionId = $this.data('id');

            $institutionInput.val(institutionId);
            $form.submit();
        });
    }
}
